<template>
  <div>
    <button type="button" class="btn btn-success" @click="listModalOpen">
      {{ $i18n.t(text) }}
    </button>
    <div id="myModal" class="modal" v-if="modalFlag">
      <div class="modal-content">
        <span class="close" @click="closeListModal">&times;</span>
        <p v-for="(list, index) in lists" :key="index">
          <confirmation-modal
            v-on:listModalClose="closeListModal"
            :text="list"
            :link="`${statusLink}&status=${index}`"
            :rowId="rowId"
            :question="question"
            :yesButtonLabel="yesButtonLabel"
            :noButtonLabel="noButtonLabel"
          ></confirmation-modal>
        </p>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
/**
 * @class ConfirmationModal
 *
 * @description This component renders the confirmation list
 */
import ConfirmationModal from './ConfirmationModal.vue'

export default {
  name: 'confirmation',
  components: {
    ConfirmationModal,
  },
  props: {
    link: {
      type: String,
      required: false,
    },
    rowId: {
      type: Number,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    lists: {
      type: Object,
      required: false,
    },
    question: {
      type: String,
      required: false,
    },
    yesButtonLabel: {
      type: String,
      required: false,
    },
    noButtonLabel: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      modalFlag: false,
    }
  },
  methods: {
    confirmed() {
      this.modalFlag = true
    },
    no() {
      this.modalFlag = false
    },
    listModalOpen() {
      this.modalFlag = true
    },
    closeListModal() {
      this.modalFlag = false
    },
  },
  computed: {
    statusLink(status) {
      return `${this.link}&modelID=${this.rowId}`
    },
  },
}
</script>
<style scoped>
/* The Modal (background) */
.modal {
  display: inline-flex;
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.3); /* Black w/ opacity */
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: auto;
}
/* The Close Button */
.close {
  color: #000;
  font-size: 28px;
  font-weight: bold;
  width: 100%;
  text-align: right;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
</style>
